import "./index.scss";
function Banner() {
  return (
    <div className="banner_container">
        <div className="row">
      <div className="title">
        <h1>台北科技大學 區塊鏈研究社</h1>
        <h2>NTUT Blockchain Club</h2>
        <div className="banner_button">
        <a href="https://forms.gle/fbDvcPQkeDDKgzZJ8">
          加入我們!</a>
        <a href="https://forms.gle/fbDvcPQkeDDKgzZJ8">
          報名茶會</a>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Banner;
